<template>
  <img
    :src="currentSrc"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    alt="Image"
  >
</template>

<script>
export default {
  props: {
    defaultSrc: {
      type: String,
      required: true,
    },
    hoverSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentSrc: this.defaultSrc,
    };
  },
  methods: {
    handleMouseEnter() {
      this.currentSrc = this.hoverSrc;
    },
    handleMouseLeave() {
      this.currentSrc = this.defaultSrc;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/service-list/components/image-hover.vue